import { Layout } from 'antd';
const { Footer, } = Layout;
const Bottombar = () => {
  return (
    <Layout>
    <Footer style={{ textAlign: 'center' }}>
    Mahnuel Portfolio ©2025 Created by Mahnuel
  </Footer>
  </Layout>

  )
}

export default Bottombar